		/**
		 * @ngdoc service
		 * @name WebCoreModule.service:WcAlertConsoleService
		 * @requires $timeout
		 * @requires _
		 * @requires $interval
		 * @description
		 * The WcAlertConsoleService manages the array of app-wide alert messages that are made visible to the user. The service exposes
		 * a configureDefaults function and an addMessage function. Messages added to the service are then displayed by the wcAlertConsole directive.
		 */

angular.module('WebCoreModule')
	.service('WcAlertConsoleService', ['$timeout', '_', '$interval', '$sce', function($timeout, _, $interval, $sce) {

		/**
		 * @ngdoc method
		 * @name WcAlertConsoleService.configureDefaults
		 * @methodOf WebCoreModule.service:WcAlertConsoleService
		 * @param {Object} config Options object to configure default values used by the WcAlertConsoleService. Config properties that can be set in this object include:
		 *  - visible: set to true to make the messages visible (default). Set to false to hide the messages in the console.
		 *  - multiple: set to true to allow multiple copies of the same message in the console (default). Set to false to allow only a single copy to be displayed in the console.
		 *  - persist: set to false to allow the messages to be cleared from the console (default). Set to true to make the messages persist in the console.
		 *  - timeout: set an {Integer} value for the length of time in seconds a message should stay in the console. (default, 7sec)
		 *  - errorOnStateChange: set to true to have messages removed when a state change occurs (default). Set to false to allow the messages to stay in the console across states.
		 * @description
		 * The WcAlertConsoleService configures itself with application-wide defaults when it starts up. The configureDefaults function allows
		 * you to override those defaults at the app level, so that the new parameters will apply to any message added to the console.
		 */
		this.configureDefaults = function(config) { // jshint ignore:line

			if(config) {
				if(config.visible !== undefined && (config.visible === true || config.visible === false)) {
					visibleDefault = config.visible;
				}
				if(config.multiple !== undefined && (config.multiple === true || config.multiple === false)) {
					multipleDefault = config.multiple;
				}
				if(config.persist !== undefined && (config.persist === true || config.persist === false)) {
					persistDefault = config.persist;
				}
				if(config.timeout !== undefined && (parseInt(config.timeout) !== 'NaN')) {
					timeoutDefault = config.timeout;
				}
				if(config.errorOnStateChange && (config.errorOnStateChange === true || config.errorOnStateChange === false)) {
					removeErrorOnStateChange = config.errorOnStateChange;
				}
			}
		};

		var visibleDefault = true;
		var multipleDefault = true;
		var persistDefault = false;
		var timeoutDefault = 7;
		var fadeOutAnimationLengthMS = 350;
		var removeErrorOnStateChange = true;

		this.getSettings = function() {
			//noinspection UnnecessaryLocalVariableJS
            var settings = {
				visible: visibleDefault,
				multiple: multipleDefault,
				persist: persistDefault,
				timeout: timeoutDefault,
				fadeOutAnimationLengthMS: fadeOutAnimationLengthMS,
				removeErrorOnStateChange: removeErrorOnStateChange
			};
			return settings;
		};

		var messages = [];

		this.isMessageDuplicate = function(msg) {

			var isDuplicate = false;

			for(var i = 0; i < messages.length; i++) {
				if(messages[i].message.$$unwrapTrustedValue() === msg.$$unwrapTrustedValue()) {
					isDuplicate = true;
				}
			}

			return isDuplicate;

		};
		/**
		 * @ngdoc method
		 * @name WcAlertConsoleService.addMessage
		 * @methodOf WebCoreModule.service:WcAlertConsoleService
		 * @param {Object} messageInstance Object to configure the message to add to the console. Config properties that can be set in this object include:
		 *  - message: Required. The string of text that will be added to the console as a message.
		 *  - type: Required. The type of message styling to apply. Can be success, info, warning, or danger.
		 *  - visible: set to true to make the messages visible (default). Set to false to hide the messages in the console.
		 *  - multiple: set to true to allow multiple copies of the same message in the console (default). Set to false to allow only a single copy to be displayed in the console.
		 *  - persist: set to false to allow the messages to be cleared from the console (default). Set to true to make the messages persist in the console.
		 *  - timeout: set an {Integer} value for the length of time in seconds a message should stay in the console. (default, 7sec)
		 *  - errorOnStateChange: set to true to have messages removed when a state change occurs (default). Set to false to allow the messages to stay in the console across states.
		 * @description
		 * The WcAlertConsoleService allows you to add messages to the alert console by leveraging the addMessage function.
		 * Messages will assume all app-wide configuration defaults, but those defaults can be overridden here by passing in the new configuration as a part of the messageInstance object.
		 */
		this.addMessage = function(messageInstance) {

			//first, trust the alert text as html
			messageInstance.message = $sce.trustAsHtml(messageInstance.message);

			if(messageInstance) {
				if(messageInstance.visible === undefined) {
					messageInstance.visible = visibleDefault;
				}
				if(messageInstance.multiple === undefined) {
					messageInstance.multiple = multipleDefault;
				}
				if(messageInstance.persist === undefined) {
					messageInstance.persist = persistDefault;
				}
				if(messageInstance.timeout === undefined) {
					messageInstance.timeout = timeoutDefault;
				}
			}

			// create identifier for message
			//noinspection UnnecessaryLocalVariableJS
            var uniqueishID = _.uniqueId('alert_');
			messageInstance.uniqueishID = uniqueishID;

			// persist danger messages by default
			if(messageInstance.type === 'danger') {
				messageInstance.persist = true;
			}

			// prevent duplicate message if multiple=false
			if(messageInstance.multiple === false) {
				if(!this.isMessageDuplicate(messageInstance.message)) {
					messages.push(messageInstance);
				}
			} else {
				messages.push(messageInstance);
			}

			if(messageInstance.persist === false) {
				$interval(function() {
					for(var f = 0; f < messages.length; f++) {
						if(messages[f].uniqueishID === messageInstance.uniqueishID) {
							messages[f].fadeOut = true;
						}
					}
				}, messageInstance.timeout * 1000 - fadeOutAnimationLengthMS,1);

				$interval(angular.bind(this, function() {
					this.removeMessage(messageInstance.uniqueishID);
				}), messageInstance.timeout * 1000,1);

				$interval(angular.bind(this, function() {
					this.updateTimeout(messageInstance.uniqueishID);
				}), 1000, messageInstance.timeout);
			}
		};

		this.updateTimeout = function(uniqueishID) {
			for(var i = 0; i < messages.length; i++) {
				if(messages[i].uniqueishID === uniqueishID) {
					messages[i].timeout --;
				}
			}
		};

		// removes a specific message
		this.removeMessage = function(uniqueishID, manualFade) {

			function foo(uniqueishID) {
				return function() {
					this.removeMessage(uniqueishID);
				};
			}

			for(var i in messages) {
				if(messages[i].uniqueishID === uniqueishID) {

					if(manualFade) {
						messages[i].fadeOut = true;
						$timeout(angular.bind(this, foo(uniqueishID)), fadeOutAnimationLengthMS);
						return;
					} else {
						messages.splice(i, 1);
						return;
					}

				}
			}
		};

		// removes all messages (includingPersistent - set to true to remove persistent msg)
		this.removeMessages = function(includingPersistent) {

			for(var i = 0; i < messages.length; i++) {
				if(messages[i].persist === false || includingPersistent === true) {
					messages.splice(i, 1);
					// reset index for accurate loop
					i = i - 1;
				}
			}

		};

		this.removeErrorMessages = function() {
			for(var i = 0; i < messages.length; i++) {
				if(messages[i].type === 'danger') {
					messages.splice(i, 1);
					// reset index for accurate loop
					i = i - 1;
				}
			}
		};

		// returns all messages (onlyVisible to only get visible messages)
		this.getMessages = function(onlyVisible) {
			var messagesToReturn = [];

			for(var i = 0; i < messages.length; i++) {
				if((onlyVisible === true && messages[i].visible === true) || onlyVisible === undefined) {
					messagesToReturn.push(messages[i]);
				}
			}

			return messagesToReturn;
		};

		// returns messages that match specific type
		this.getMessagesByType = function(typeToMatch) {

			var messagesToReturn = [];

			for(var i = 0; i < messages.length; i++) {
				if(messages[i].type === typeToMatch) {
					messagesToReturn.push(messages[i]);
				}
			}

			return messagesToReturn;
		};


	}]);